// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import Rails from "@rails/ujs"
Rails.start()

require("../channels")
require("@fortawesome/fontawesome-free/js/all")

var jQuery = require("jquery")
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

// Tabler UI を DOM 準備完了後に読み込む
// 即時実行すると内部のテーマオブジェクトアクセスで null エラーが発生するケースがあるため
document.addEventListener('DOMContentLoaded', function() {
  require('@tabler/core/dist/js/tabler.min.js');
});

require.context('../images', true)

import * as Sentry from '@sentry/browser'
window.Sentry = Sentry;

import '../styles/application.scss';
import '../src/common.js';
import '../src/absence_post.js';
import '../src/editable-rows.js';
import '../src/csv_preview.js';
import '../src/c4th_csv_preview.js';

import Sortable from 'sortablejs';
window.Sortable = Sortable;
